import { useVariant } from '@unleash/proxy-client-react';
import type { FC } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { useAuth } from '@furality/frontend-stack';
import Placeholder from '@/components/Placeholder.tsx';
import useLoading from '@/lib/hooks/useLoading.ts';
import usePetFynn from '@/lib/hooks/usePetFynn.ts';

const HONSE = 'https://media.cdn.furality.online/image/f7/portal/explore/hoooooonse.webp';
const FynnSmileCrop = 'https://cdn.furality.org/files/web/fynn/fynn-smile-crop.png';

const UserTopContainer: FC = () => {
  const { t } = useTranslation(['common', 'profile']);
  const auth = useAuth();

  const loading = useLoading();

  const { petFynn, petStyles, petCount } = usePetFynn();
  const stateVariant = useVariant('portal.profile.bannerState');
  const state = (stateVariant.enabled && stateVariant.name) || 'after';

  const isHonse = !(petCount === 0 || petCount % 150);

  return (
    <section className="bg-section-secondary align-items-end position-relative main-background-1">
      {/* <span className="mask bg-dark opacity-7" /> */}
      <Container className="h-100">
        <Row className="align-items-center h-100">
          <Col xl="auto" className="d-none d-xl-block mb-md-0 h-100">
            <button
              type="button"
              onClick={petFynn}
              className="unstyled-button d-flex justify-content-center align-items-end mt-md-6"
              style={{
                height: 'calc(100% - 2rem)',
                width: '174px',
                ...petStyles,
              }}
            >
              {isHonse ? (
                <img
                  src={HONSE}
                  draggable="false"
                  alt="horse smiling"
                  className="ms-auto"
                  style={{
                    height: '120%',
                  }}
                />
              ) : (
                <img
                  src={FynnSmileCrop}
                  draggable="false"
                  alt="fynn smiling"
                  className="img-fluid"
                />
              )}
            </button>
          </Col>
          <Col lg={7} md={9} sm={8} className="alert alert-dark my-4 my-xl-6">
            <span className="h2 mb-0 text-white d-block">
              {loading ? (
                <Placeholder width="12em" />
              ) : auth.user?.name ? (
                t('f7.shared.user_top_container.welcome_username', { username: auth.user.name })
              ) : (
                t('f7.shared.user_top_container.welcome')
              )}
            </span>
            <span className="text-white">
              {loading ? (
                <>
                  <Placeholder width="8em" />
                  <br />
                  <Placeholder width="25em" />
                </>
              ) : (
                <Trans
                  ns="profile"
                  i18nKey={
                    state === 'during'
                      ? 'banner.during_con'
                      : state === 'before'
                        ? 'banner.pre_con'
                        : 'banner.post_con'
                  }
                />
              )}
            </span>
            <div>
              Age Verification will be available in the coming weeks.{' '}
              <a href="https://furality.org/ageverification">Learn More</a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UserTopContainer;
